<template>
  <BaseModal
    :bem="bemBlock"
    :is-open="true"
    :modal-modifier="'bottom'"
    :show-backdrop="true"
    v-on="$listeners"
  >
    <BaseSpinner
      v-if="currentItem === items.LOADING"
      :class="bemElement('loading')"
    />
    <div
      v-if="currentItem === items.SIZE_SELECTION"
      :class="bemElement('selector')"
    >
      <span :class="bemElement('title')">{{
        $msg('button.sizeselect', 'product')
      }}</span>
      <TheProductDetailsSizeSelector
        :class="[bemElement('sizes'), 'u-scroll-disabled']"
        prefix="modalSizeSelector"
        :data-context="context"
        :product="product"
        v-on="$listeners"
      />
    </div>
    <div
      v-if="currentItem === items.ADDED_TO_CART"
      :class="bemElement('added-msg')"
    >
      <BaseProductTileImage
        :class="bemElement('image')"
        :context="context"
        :force-main-image-to-load="true"
        :has-carousel="false"
        :product="product"
        url=""
        v-on="$listeners"
      />
      <div :class="bemElement('text')">
        {{ addedMessage }}
        <a
          :href="cartShowUrl"
          :class="['link', 'link--arrow', bemElement('link')]"
        >
          {{ $msg('button.productcard', 'product') }}
        </a>
      </div>
    </div>
    <TheProductDetailsStockAlert
      v-if="currentItem === items.STOCK_ALERT"
      :class="bemElement('stock-alert')"
      :product="product"
      :stock-alert-visible="true"
      :stock-alert-size="selectedSize"
      v-on="$listeners"
    />
  </BaseModal>
</template>

<script>
import getFrontConfig from '../../common/getFrontConfig';
import { ITEMS } from '../config/modalSizeSelectorConfig';
import bemClassesMixin from '../mixins/bemClassesMixin';
import productPropSizesMixin from '../mixins/productPropSizesMixin';
import BaseModal from './BaseModal.vue';
import BaseProductTileImage from './BaseProductTileImage.vue';
import BaseSpinner from './BaseSpinner.vue';
import TheProductDetailsSizeSelector from './TheProductDetailsSizeSelector.vue';
import TheProductDetailsStockAlert from './TheProductDetailsStockAlert.vue';

const {
  urls: { cartShow },
  vue: {
    BaseProductTile: {
      context: { plpGrid },
    },
  },
} = getFrontConfig();

export default {
  name: 'BaseModalSizeSelector',

  components: {
    BaseModal,
    BaseProductTileImage,
    BaseSpinner,
    TheProductDetailsSizeSelector,
    TheProductDetailsStockAlert,
  },

  mixins: [bemClassesMixin, productPropSizesMixin],

  props: {
    context: {
      type: String,
      required: false,
      default: plpGrid,
    },
    currentItem: {
      type: Number,
      required: false,
      default: ITEMS.LOADING,
    },
  },

  data() {
    return {
      cartShowUrl: cartShow,
      items: ITEMS,
    };
  },

  computed: {
    addedMessage() {
      const lastSelectedSize = this.getLastSelectedSize()?.displayValue;
      let msg = '';

      if (lastSelectedSize === 'UN' || !lastSelectedSize) {
        msg = this.$msg('text.alert.addedtobasket.modal', 'product');
      } else {
        msg = this.$msg('button.sizeaddedmobile', 'product', [
          lastSelectedSize,
        ]);
      }

      return msg;
    },
  },
};
</script>
